<script>
import { toThaiDatetime } from '@/utils/datetime'
import { BranchProvider } from '@/providers'
import { mapGetters } from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },

    readonly: {
      type: Boolean,
      default: false
    },

    disabledInfo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('auth', ['userBranchId'])
  },

  methods: {
    emit(key, value) {
      this.$emit('change', { ...this.data, [key]: value })
    }
  },

  render() {
    const Information = ({ slots }) => {
      const Form = () => (
        <el-form labelWidth="6rem">
          <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
            <el-col sm={12}>
              <el-form-item label="วันที่โอน:">
                <el-date-picker
                  value={this.data.datetime}
                  type="datetime"
                  style={{ width: '100%' }}
                  onInput={value => {
                    this.emit('datetime', value)
                  }}
                />
              </el-form-item>
            </el-col>
            <el-col sm={12}>
              <el-form-item label="ผู้โอน:">
                {this.data.transferor}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
            <el-col sm={12}>
              <el-form-item label="ปลายทาง:">
                <BranchProvider
                  branchId={this.userBranchId}
                  scopedSlots={{
                    default: ({ items }) => (
                      <el-select
                        value={this.data.destination}
                        valueKey="id"
                        filterable
                        style={{ width: '100%' }}
                        onChange={value => {
                          this.emit('destination', value)
                        }}
                        nativeOnTouchend={e => {
                          e.target.readOnly = false
                        }}
                      >
                        {items.map((item, index) => (
                          <el-option
                            key={index}
                            label={item.name}
                            value={item}
                          />
                        ))}
                      </el-select>
                    )
                  }}
                />
              </el-form-item>
            </el-col>
            <el-col sm={12}>
              <el-form-item label="ผู้ขนส่ง:">
                <el-input
                  value={this.data.carrier}
                  onInput={value => {
                    this.emit('carrier', value)
                  }}
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      )

      const ReadonlyForm = () => (
        <el-form labelWidth="6rem">
          <el-form-item label="วันที่โอน:" style={{ marginBottom: '0' }}>
            {toThaiDatetime(this.data.datetime, 'D MMMM Y H:mm น.')}
          </el-form-item>
          <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
            <el-col sm={12}>
              <el-form-item label="ต้นทาง:" style={{ marginBottom: '0' }}>
                {this.data.origin && this.data.origin.name}
              </el-form-item>
            </el-col>
            <el-col sm={12}>
              <el-form-item label="ผู้ขนส่ง:" style={{ marginBottom: '0' }}>
                {this.data.carrier}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
            <el-col sm={12}>
              <el-form-item label="ปลายทาง:" style={{ marginBottom: '0' }}>
                {this.data.destination && this.data.destination.name}
              </el-form-item>
            </el-col>
            <el-col sm={12}>
              <el-form-item label="ผู้โอน:" style={{ marginBottom: '0' }}>
                {this.data.transferor}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      )

      return (
        <el-card>
          {slots().header && (
            <div style={{ marginBottom: '1rem' }}>{slots().header}</div>
          )}
          {this.readonly || this.disabledInfo ? <ReadonlyForm /> : <Form />}
          {slots().default}
        </el-card>
      )
    }

    const Note = () => (
      <el-card style={{ marginTop: '1.5rem' }}>
        <el-form labelPosition="top">
          <el-form-item label="หมายเหตุ">
            {this.readonly ? (
              <div style={{ lineHeight: '1.5' }}>{this.data.note}</div>
            ) : (
              <el-input
                value={this.data.note}
                type="textarea"
                autosize={{ minRows: 3 }}
                onInput={value => {
                  this.emit('note', value)
                }}
              />
            )}
          </el-form-item>
        </el-form>
      </el-card>
    )

    return (
      <div>
        <Information>
          <template slot="header">{this.$slots.header}</template>
          {this.readonly && this.$slots.default}
        </Information>
        {!this.readonly && this.$slots.default}
        {(!this.readonly || (this.readonly && this.data.note)) && <Note />}
      </div>
    )
  }
}
</script>
